const WORDS = [
    "KNOW YOUR NUMBERS",
    "A CLEAR PLAN",
    "FASTER TO YOUR GOAL",
    "REAL WEALTH",
];

export const Marquee = () => {
    const sequence = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
    return (
        <div
            data-testid="marquee"
            aria-hidden="true"
            className="relative py-10 border-y border-white/10 overflow-hidden select-none"
        >
            <div className="marquee-track">
                {[0, 1].map((dup) => (
                    <div key={dup} className="flex items-center shrink-0">
                        {sequence.map((w, i) => (
                            <span
                                key={`${dup}-${i}`}
                                className="font-display italic text-[7vw] md:text-[5vw] leading-none text-white/[0.07] px-6 flex items-center gap-6"
                            >
                                {w}
                                <span className="text-[#C5A059]/20 not-italic">
                                    =
                                </span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
